import React, { Component } from "react";

import classes from "./Modal.module.css";
import Aux from "../../../hoc/Auxiliary/Auxiliary";
import Backdrop from "../Backdrop/Backdrop";

class Modal extends Component {
  render() {
    return (
      <Aux>
        <Backdrop show={this.props.show} click={this.props.close} />
        <div
          className={classes.Modal}
          style={{
            transform: this.props.show ? "translateY(200px)" : "translateY(-100vh)",
            opacity: this.props.show ? "1" : "0",
            width: `${this.props.size}px`,
            left: `calc(50% - ${this.props.size / 2}px)`
          }}
        >
          {this.props.children}
        </div>
      </Aux>
    );
  }
}

export default Modal;
